import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

export const signInSuccess = createAction('ACCOUNT_LOCAL_SIGN_IN_SUCCESS');
export const signInFailure = createAction('ACCOUNT_LOCAL_SIGN_IN_FAILURE', (error: AxiosError) => ({
  payload: error,
}));

export const signUpSuccess = createAction('ACCOUNT_LOCAL_SIGN_UP_SUCCESS');
export const signUpFailure = createAction('ACCOUNT_LOCAL_SIGN_UP_FAILURE', (error: AxiosError) => ({
  payload: error,
}));

export type AccountLocalAction =
  | ReturnType<typeof signInSuccess>
  | ReturnType<typeof signInFailure>
  | ReturnType<typeof signUpSuccess>
  | ReturnType<typeof signUpFailure>;
